import axios from 'axios'
import { Toast } from 'vant'
import { userApi, traceApi } from '@/api/index.js'
import router from '../router'
import env from './env'
import store from '@/store/index.js'

// ✅ 全局安全获取 traceId（永远唯一、不冲突、不丢失、不重复）
function getSafeTraceId() {
  let traceId = localStorage.getItem('traceId')
  if (!traceId) {
    traceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    }).replace(/-/g, '').substring(0, 26)
    localStorage.setItem('traceId', traceId)
  }
  return traceId
}

// 创建axios实例
var tokens = ''
if (localStorage.getItem('tokens')) {
  tokens = 'Bearer ' + localStorage.getItem('tokens')
}
const service = axios.create({
  baseURL: env.ApiUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    Toast.clear()
    return Promise.reject(error)
  }
)

// 同步执行埋点函数（核心：强制等待请求完成）
const syncTrack = (apiFunc, params) => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }

    const requestPromise = apiFunc(params)
    return new Promise((resolve) => {
      requestPromise
        .then(() => resolve(true))
        .catch(err => {
          console.error('埋点请求失败:', err)
          resolve(false)
        })
    })
  } catch (err) {
    console.error('埋点执行异常:', err)
    return Promise.resolve(false)
  }
}

// 响应拦截器
service.interceptors.response.use(
  async response => {
    var res = response.data

    if (res.code == 20000) {
      if (response.config.url == '/am/api/am/command/v2/prepare') {
        localStorage.setItem('qb', res.data.enableJumpBottom)
        localStorage.setItem('llg', res.data.enableJumpBottomLlg)
        localStorage.setItem('productCode', JSON.parse(response.config.data).productCode)
        localStorage.setItem('channelCode', JSON.parse(response.config.data).channelCode)

        await syncTrack(traceApi.event, {
          t: getSafeTraceId(),
          e: 11,
          f: res.data.reason
        })

        if (res.data.jumpBottomUrl == '0') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 110,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '1',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])
          return res.data
        } else if (res.data.jumpBottomUrl == '3') {
          await syncTrack(traceApi.event, {
            t: getSafeTraceId(),
            e: 112,
            f: res.data.reason
          })

          if (localStorage.getItem('qb') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '9',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            const urlRes = await userApi.geturl({
              channelCode: localStorage.getItem('channelCode'),
              traceId: JSON.parse(response.config.data).traceId
            })
            window.location.href = urlRes.productLink
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转qb兜底')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '2' || res.data.jumpBottomUrl == '5') {
          await syncTrack(traceApi.event, {
            t: getSafeTraceId(),
            e: 112,
            f: res.data.reason
          })

          if (localStorage.getItem('llg') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '8',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            var codex = res.data.jumpBottomUrl == '2' ? 'xxl' : 'defaultUrl'
            const resx = await userApi.queryByCode({ code: codex })
            window.location.href = resx.value + '&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转llg兜底')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '4') {
          await syncTrack(traceApi.event, {
            t: getSafeTraceId(),
            e: 113,
            f: res.data.reason
          })

          await syncTrack(userApi.statistics, {
            a: localStorage.getItem('channelCode'),
            proCode: localStorage.getItem('productCode'),
            flowType: '2',
            traceId: JSON.parse(response.config.data).traceId,
            jumpBottomUrl: res.data.jumpBottomUrl
          })

          const auditRes = await userApi.getAuditLink({
            productCode: localStorage.getItem('productCode')
          })
          window.location.href = auditRes.productLink
          const error = new Error('请求资源不存在，跳转审核链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else {
          await Promise.all([
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '3',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            }),
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 111,
              f: res.data.reason
            })
          ])

          store.commit('setLoading', false)
          router.replace({ path: '/404' }).catch(err => {
            console.error('路由跳转404失败：', err)
          })
          const error = new Error('请求资源不存在，跳转404页面')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        }
      } else if (response.config.url == '/am/api/am/command/v2/generateToken') {
        await syncTrack(traceApi.event, {
          t: getSafeTraceId(),
          e: 10,
          f: res.data.reason
        })

        if (res.data.jumpBottomUrl == '0') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 100,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '14',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])
          return res.data
        } else if (res.data.jumpBottomUrl == '4') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 103,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '5',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          const auditRes = await userApi.getAuditLink({
            productCode: localStorage.getItem('productCode')
          })
          window.location.href = auditRes.productLink
          const error = new Error('请求资源不存在，跳转审核链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '3') {
          await syncTrack(traceApi.event, {
            t: getSafeTraceId(),
            e: 102,
            f: res.data.reason
          })

          if (localStorage.getItem('qb') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '13',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            const urlRes = await userApi.geturl({
              channelCode: localStorage.getItem('channelCode'),
              traceId: JSON.parse(response.config.data).traceId
            })
            window.location.href = urlRes.productLink+'&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转qb兜底')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '2') {
          await syncTrack(traceApi.event, {
            t: getSafeTraceId(),
            e: 102,
            f: res.data.reason
          })

          if (localStorage.getItem('llg') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '12',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            const resx = await userApi.queryByCode({ code: 'xxl' })
            window.location.href = resx.value + '&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转llg链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 101,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '15',
              traceId: getSafeTraceId(),
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          store.commit('setLoading', false)
          router.replace({ path: '/404' }).catch(err => {
            console.error('路由跳转404失败：', err)
          })
          const error = new Error('请求资源不存在，跳转404页面')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        }
      } else if (response.config.url == '/am/api/am/command/encrypt/v2/signOrder') {
        await syncTrack(traceApi.event, {
          t: getSafeTraceId(),
          e: 24,
          f: res.data.reason
        })

        if (res.data.jumpBottomUrl == '0') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 240,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '4',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])
          return res.data
        } else if (res.data.jumpBottomUrl == '2') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 242,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '10',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          if (localStorage.getItem('llg') == '1') {
            const resx = await userApi.queryByCode({ code: 'xxl' })
            window.location.href = resx.value + '&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转llg链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '3') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 242,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '11',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          if (localStorage.getItem('qb') == '1') {
            const urlRes = await userApi.geturl({
              channelCode: localStorage.getItem('channelCode'),
              traceId: JSON.parse(response.config.data).traceId
            })
         
            window.location.href = urlRes.productLink+'&mobile='+localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转qb链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: getSafeTraceId(),
              e: 241,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '7',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          store.commit('setLoading', false)
          router.replace({ path: '/404' }).catch(err => {
            console.error('路由跳转404失败：', err)
          })
          const error = new Error('请求资源不存在，跳转404页面')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        }
      } else {
        return res.data
      }
    } else {
      Toast.fail(res.message)
      store.commit('setLoading', false)
      return Promise.reject(res)
    }
  },
  error => {
    Toast.clear()
    if (error.response) {
      const { data, status } = error.response
      if (status === 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('tokens')
        sessionStorage.removeItem('token')
        Toast.fail(data?.message || '登录已过期，请重新登录')
      } else {
        Toast.fail(data?.message || '请求失败')
      }
    } else {
      Toast.fail(error.message || '网络请求失败')
    }
    return Promise.reject(error)
  }
)

export default service